function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React, { PureComponent } from 'react';
import classNames from 'classnames';
import parse from 'date-fns/parse';
var styles = {
  "root": "Cal__Day__root",
  "enabled": "Cal__Day__enabled",
  "highlighted": "Cal__Day__highlighted",
  "today": "Cal__Day__today",
  "disabled": "Cal__Day__disabled",
  "selected": "Cal__Day__selected",
  "month": "Cal__Day__month",
  "year": "Cal__Day__year",
  "selection": "Cal__Day__selection",
  "day": "Cal__Day__day",
  "range": "Cal__Day__range",
  "start": "Cal__Day__start",
  "end": "Cal__Day__end",
  "betweenRange": "Cal__Day__betweenRange",
  "tripInfo": "Cal__Day__tripInfo"
};
import { differenceInCalendarDays } from 'date-fns';

var Day = /*#__PURE__*/function (_PureComponent) {
  _inheritsLoose(Day, _PureComponent);

  function Day() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _PureComponent.call.apply(_PureComponent, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "handleClick", function () {
      var _this$props = _this.props,
          date = _this$props.date,
          isDisabled = _this$props.isDisabled,
          onClick = _this$props.onClick;

      if (!isDisabled && typeof onClick === 'function') {
        onClick(parse(date));
      }
    });

    return _this;
  }

  var _proto = Day.prototype;

  _proto.renderSelection = function renderSelection(selectionColor) {
    var _this$props2 = this.props,
        day = _this$props2.day,
        date = _this$props2.date,
        isToday = _this$props2.isToday,
        todayLabel = _this$props2.locale.todayLabel,
        monthShort = _this$props2.monthShort,
        textColor = _this$props2.theme.textColor,
        selectionStyle = _this$props2.selectionStyle,
        selected = _this$props2.selected,
        className = _this$props2.className,
        dayOfWeek = _this$props2.dayOfWeek;

    var updatedSelectionStyle = _extends({}, selectionStyle);

    if (selected.end && selected.end === date || selected.start && selected.start === date) {
      if (dayOfWeek === 0) updatedSelectionStyle.marginLeft = '-16px';else if (dayOfWeek === 6) updatedSelectionStyle.marginLeft = '-29px';
    } else if (dayOfWeek === 0) {
      updatedSelectionStyle.paddingLeft = '12px';
    } else if (dayOfWeek === 6) {
      updatedSelectionStyle.paddingRight = '12px';
    }

    return /*#__PURE__*/React.createElement("div", {
      className: styles.selection,
      "data-date": date,
      style: _extends({
        backgroundColor: this.selectionColor,
        color: textColor.active
      }, updatedSelectionStyle)
    }, /*#__PURE__*/React.createElement("span", {
      className: styles.month
    }, isToday ? todayLabel["short"] || todayLabel["long"] : monthShort), /*#__PURE__*/React.createElement("span", {
      className: styles.day
    }, day), selected.start && selected.end && className === 'Cal__Day__range Cal__Day__end' && /*#__PURE__*/React.createElement("span", {
      className: styles.tripInfo,
      style: {
        left: dayOfWeek === 0 ? '-16px' : ''
      }
    }, differenceInCalendarDays(new Date(selected.end), new Date(selected.start)), "-Day Trip"));
  };

  _proto.render = function render() {
    var _classNames;

    var _this$props3 = this.props,
        className = _this$props3.className,
        currentYear = _this$props3.currentYear,
        date = _this$props3.date,
        day = _this$props3.day,
        handlers = _this$props3.handlers,
        isDisabled = _this$props3.isDisabled,
        isHighlighted = _this$props3.isHighlighted,
        isToday = _this$props3.isToday,
        isSelected = _this$props3.isSelected,
        _this$props3$theme = _this$props3.theme,
        selectionColor = _this$props3$theme.selectionColor,
        todayColor = _this$props3$theme.todayColor,
        year = _this$props3.year,
        dayOfWeek = _this$props3.dayOfWeek;
    var listItemStyle = {};

    if (isSelected) {
      listItemStyle.color = this.selectionColor = typeof selectionColor === 'function' ? selectionColor(date) : selectionColor;
    } else if (isToday) {
      listItemStyle.color = todayColor;
    }

    if (dayOfWeek === 0) {
      listItemStyle.width = '18.125%';
      listItemStyle.paddingLeft = '12px';
    } else if (dayOfWeek === 6) {
      listItemStyle.width = '18.125%';
      listItemStyle.paddingRight = '12px';
    }

    return /*#__PURE__*/React.createElement("li", _extends({
      style: _extends({}, listItemStyle),
      className: classNames(styles.root, (_classNames = {}, _classNames[styles.today] = isToday, _classNames[styles.highlighted] = isHighlighted, _classNames[styles.selected] = isSelected, _classNames[styles.disabled] = isDisabled, _classNames[styles.enabled] = !isDisabled, _classNames), className),
      onClick: this.handleClick,
      "data-date": date
    }, handlers), isToday ? /*#__PURE__*/React.createElement("span", null, day) : day, day === 1 && currentYear !== year && /*#__PURE__*/React.createElement("span", {
      className: styles.year
    }, year), isSelected && this.renderSelection());
  };

  return Day;
}(PureComponent);

export { Day as default };